import { Typography } from '@smartgift/frontend-toolkit';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { configs } from '@hero/configs';

import { SignInEmailForm } from './SignInEmailForm';
import { SignInRedirectForm } from './SignInRedirectForm';
import * as S from './style';

export const SignInTemplate = () => {
  const { t } = useTranslation();

  const renderContent = useMemo(() => {
    if (configs.publicLogin.enabled) {
      return configs.publicLogin.isBackendRedirect ? <SignInRedirectForm /> : <SignInEmailForm />;
    }

    return (
      <S.PublicLoginDisabledWrapper>
        <Typography variant="subtitle3Bold">{t('welcome')}</Typography>
        <Typography variant="body1">{t('yourGiftingJourneyBeginsHere')}</Typography>
      </S.PublicLoginDisabledWrapper>
    );
  }, [configs.publicLogin]);

  return (
    <S.SignInTemplate hasMultipleRows={configs.publicLogin.isBackendRedirect}>
      {renderContent}
    </S.SignInTemplate>
  );
};
